import z from "zod";
import { AssetIdSchema, ChunkIdSchema, ConceptIdSchema, LabelIdSchema, SeedIdSchema } from "./idTypes";

export const ChunkSchema = z.object({
  id: ChunkIdSchema,
  text: z.string(),
  assetId: AssetIdSchema,
  modifiedAt: z.string(),
  distanceFromSeed: z.number(),
});
export type Chunk = z.infer<typeof ChunkSchema>;
export const SeedSchema = z.object({
  id: SeedIdSchema,
  assetId: z.string(),
  name: z.string(),
  description: z.string(),
  summary: z.string(),
  chunks: z.array(ChunkSchema).optional(),
  distanceFromConcept: z.number(),
  distances: z.record(z.string(), z.number()).optional(),
  createdAt: z.string(),
  createdBy: z.string(),
});
export type Seed = z.infer<typeof SeedSchema>;

export const ConceptSchema = z.object({
  id: ConceptIdSchema,
  name: z.string(),
  description: z.string(),
  labels: z.array(LabelIdSchema).optional(),
  summary: z.string(),
  distances: z.record(ConceptIdSchema, z.number()).optional(),
  seeds: z.array(SeedSchema).optional(),
  score: z.number(),
  createdAt: z.string(),
  modifiedAt: z.string(),
});
export type Concept = z.infer<typeof ConceptSchema>;
